<template>
  <svg
    xmlns:dc="http://purl.org/dc/elements/1.1/"
    xmlns:cc="http://creativecommons.org/ns#"
    xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
    xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    version="1.1"
    v-on="$listeners"
  >
    <metadata id="metadata10">
      <rdf:RDF>
        <cc:Work rdf:about="">
          <dc:format>image/svg+xml</dc:format>
          <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
        </cc:Work>
      </rdf:RDF>
    </metadata>
    <defs id="defs8" />
    <sodipodi:namedview
      pagecolor="#ffffff"
      bordercolor="#666666"
      borderopacity="1"
      objecttolerance="10"
      gridtolerance="10"
      guidetolerance="10"
      inkscape:pageopacity="0"
      inkscape:pageshadow="2"
      inkscape:window-width="1366"
      inkscape:window-height="705"
      id="namedview6"
      showgrid="false"
      inkscape:zoom="11.208333"
      inkscape:cx="25.990127"
      inkscape:cy="15.971517"
      inkscape:window-x="-8"
      inkscape:window-y="-8"
      inkscape:window-maximized="1"
      inkscape:current-layer="svg4"
      inkscape:document-rotation="0"
    />
    <path
      id="path902"
      style="fill:none;stroke:currentColor;stroke-width:1.8;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
      d="M 17.451924,23.065465 V 3.8292878 h 3.662463 V 23.006094 m -10.835132,0.05664 V 7.8981169 H 14.02926 V 23.015933 M 3.0696438,22.83771 V 12.61752 h 3.879887 V 22.806166 M 0.17843888,22.929367 H 23.910781"
    />
  </svg>
</template>
<script>
import { Component, Vue } from "vue-property-decorator";

@Component
export default class BarIcon extends Vue {}
</script>
